import React from 'react';
import proptypes from 'prop-types';
const { string: stringType } = proptypes;
import { Typography, Alert } from '@one-thd/sui-atomic-components';

const SmartFilterAlertMessage = ({displayAs}) => (
  <div data-testid="smart-filter-alert-display" className="sui-mr-4">
    <Alert data-testid="alert" status={displayAs}>
      <Typography data-testid="typography">
        {
          displayAs === 'success' ? "Filters found and applied."
            : "There are no filters that match that prompt, please try again."
        }
      </Typography>
    </Alert>
  </div>
);

SmartFilterAlertMessage.displayName = 'SmartFilterAlertMessage';

SmartFilterAlertMessage.defaultProps = {
  displayAs: ''
};

SmartFilterAlertMessage.propTypes = {
  displayAs: stringType
};

export { SmartFilterAlertMessage };
